import classNames from 'classnames';
import FadeUp from '../../Animation/FadeUp';
var classes = {
    base: 'flex flex-col w-full dark',
};
var ReassuranceItem = function (_a) {
    var icon = _a.icon, children = _a.children, className = _a.className;
    var Icon = icon;
    return (<FadeUp>
      <div className={classNames(classes.base, className)}>
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white">
          {<Icon size={28}/>}
        </div>
        <div className="mt-4">{children}</div>
      </div>
    </FadeUp>);
};
export default ReassuranceItem;
